var l;
((a) => {
  ((d) => {
    d[d.None = 0] = "None", d[d.EnableMultipleProjectsForEvent = 1] = "EnableMultipleProjectsForEvent", d[d.CreationFromStudent = 2] = "CreationFromStudent";
  })(a.ProjectConfigFlags || (a.ProjectConfigFlags = {})), ((d) => {
    d[d.None = 0] = "None", d[d.NextEvent = 1] = "NextEvent", d[d.NextClass = 2] = "NextClass", d[d.NextDay = 3] = "NextDay", d[d.NextWeek = 4] = "NextWeek", d[d.NextTeacher = 5] = "NextTeacher";
  })(a.RecurrenceType || (a.RecurrenceType = {}));
  class f extends Array {
    constructor(s) {
      super(...s || []), Object.setPrototypeOf(this, f.prototype);
    }
    hasReadOrEdit(s, N) {
      const r = this.find((v) => v.FeatureName === N);
      return r ? ((r.Read || 0) & s) > 0 || ((r.Edit || 0) & s) > 0 : !1;
    }
    hasRead(s, N) {
      const r = this.find((v) => v.FeatureName === N);
      return r ? ((r.Read || 0) & s) > 0 : !1;
    }
    hasEdit(s, N) {
      const r = this.find((v) => v.FeatureName === N);
      return r ? ((r.Edit || 0) & s) > 0 : !1;
    }
  }
  a.ProjectConfigPermissions = f, ((d) => {
    d[d.None = 0] = "None", d[d.UnMarked = 1] = "UnMarked", d[d.Attended = 2] = "Attended", d[d.Absent = 3] = "Absent", d[d.Approved = 4] = "Approved";
  })(a.AttendeeStatusEnum || (a.AttendeeStatusEnum = {})), ((d) => {
    d[d.None = 0] = "None", d[d.Person = 1] = "Person", d[d.AllPeople = 2] = "AllPeople", d[d.Parents = 4] = "Parents", d[d.Author = 8] = "Author", d[d.LastModifier = 16] = "LastModifier", d[d.CaseManager = 32] = "CaseManager", d[d.Teachers = 64] = "Teachers", d[d.EventStaff = 128] = "EventStaff", d[d.EventAuthor = 256] = "EventAuthor", d[d.ContactType = 512] = "ContactType", d[d.StaffGroup = 1024] = "StaffGroup";
  })(a.RecipientEnum || (a.RecipientEnum = {})), ((d) => {
    d[d.Created = 1] = "Created", d[d.Deleted = 2] = "Deleted", d[d.PersonAdded = 3] = "PersonAdded", d[d.PersonRemoved = 4] = "PersonRemoved", d[d.RecordAdded = 5] = "RecordAdded", d[d.RecordRemoved = 6] = "RecordRemoved", d[d.EventAdded = 7] = "EventAdded", d[d.EventRemoved = 8] = "EventRemoved", d[d.Updated = 9] = "Updated";
  })(a.ProjectActionType || (a.ProjectActionType = {}));
})(l || (l = {}));
export {
  l as projects
};
//# sourceMappingURL=index.js.map
